export default __webpack_public_path__ + "static/media/Foto2.a2df7f02.png";